import React, { useEffect, useState } from "react";
import Icon from "../../../assets/images/Frame 1000003923.svg";
import "./styles.scss";

interface Props {
  src: string;
  alt?: string;
  onClick?: any;
  classname?: any;
}

const ImageDisplay: React.FC<Props> = ({ classname, src, onClick, alt }) => {
  const [isLoad, setIsLoad] = useState(false);
  function testImage(url: string) {
    // Define the promise
    const imgPromise = new Promise(function imgPromise(resolve, reject) {
      // Create the image
      const imgElement = new Image();

      // When image is loaded, resolve the promise
      imgElement.addEventListener("load", function imgOnLoad() {
        resolve(this);
      });

      // When there's an error during load, reject the promise
      imgElement.addEventListener("error", function imgOnError() {
        reject();
      });

      // Assign URL
      imgElement.src = url;
    });

    return imgPromise;
  }
  useEffect(() => {
    if (!src) return;
    testImage(src).then(
      function fulfilled(img) {
        setIsLoad(true);
      },

      function rejected() {
        setIsLoad(false);
      }
    );
  }, [src]);

  if (isLoad) {
    return (
      <>
        <img src={src} alt={alt} className={classname} onClick={onClick} />
      </>
    );
  } else {
    return (
      <>
        <img src={Icon} alt="No Image Available" className="no-pic" />
      </>
    );
  }
};

export default ImageDisplay;
